import { RouteObject } from 'react-router-dom'
import { RoutesEnum } from '../../enums/RoutesEnum'
import { Project } from '../../../pages/Project/Project'
import { DocumentationSection } from '../../../pages/Project/subpages/DocumentationSection'
import { FolderKeyEnum } from '../../enums/FolderKeyEnum'
import { Issues } from '../../../pages/Project/subpages/Issues/Issues'
import { IssueForm } from '../../../pages/Project/subpages/Issues/IssueForm'
import { Settings } from '../../../pages/Project/subpages/Settings/Settings'
import { BasicInformation } from '../../../pages/Project/subpages/Settings/BasicInformation/BasicInformation'
import { ProjectOptions } from '../../../pages/Project/subpages/Settings/ProjectOptions/ProjectOptions'
import { ObjectsAndRooms } from '../../../pages/Project/subpages/Settings/ObjectsAndRooms/ObjectsAndRooms'
import { ConstructionDiaryInfo } from '../../../pages/Project/subpages/Settings/ConstructionDiaryInfo/ConstructionDiaryInfo'
import { PhotoDocumentation } from '../../../pages/Project/subpages/PhotoDocumentation/PhotoDocumentation'
import { ConstructionDiary } from '../../../pages/Project/subpages/ConstructionDiary/ConstructionDiary'
import { ConstructionDiaryEntry } from '../../../pages/Project/subpages/ConstructionDiary/ConstructionDiaryEntry/ConstructionDiaryEntry'
import { Tasks } from '../../../pages/Project/subpages/Tasks/Tasks'
import React from 'react'
import { buildingPermitRoutes } from './buildingPermitRoutes'
import { demolitionPermitRoutes } from './demolitionPermitRoutes'

export const projectSubpageRoutes: RouteObject[] = [
  {
    path: `${RoutesEnum.PROJECTS}/:id`,
    element: <Project />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.ENGINEERING}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.ENGINEERING} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.RESEARCH_AND_SURVEY}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.PROJECT_RESEARCH_AND_SURVEYS} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.ISSUES}`,
    element: <Issues />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.ISSUES}/${RoutesEnum.ISSUES_FORM}?/:issueId`,
    element: <IssueForm />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SETTINGS}`,
    element: <Settings />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SETTINGS}/${RoutesEnum.SETTINGS_BASIC_INFO}`,
    element: <BasicInformation />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SETTINGS}/${RoutesEnum.SETTINGS_PROJECT_OPTIONS}`,
    element: <ProjectOptions />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SETTINGS}/${RoutesEnum.SETTINGS_OBJECTS_AND_ROOMS}`,
    element: <ObjectsAndRooms />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SETTINGS}/${RoutesEnum.SETTINGS_CONSTRUCTION_DIARY_INFO}`,
    element: <ConstructionDiaryInfo />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.PHOTO_DOCUMENTATION}`,
    element: <PhotoDocumentation />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.CONSTRUCTION_DIARY}`,
    element: <ConstructionDiary />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.CONSTRUCTION_DIARY}/${RoutesEnum.CONSTRUCTION_DIARY_ENTRY}/:date`,
    element: <ConstructionDiaryEntry />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TASKS}`,
    element: <Tasks />,
  },
  ...buildingPermitRoutes,
  ...demolitionPermitRoutes,
]
